<avr-navbar></avr-navbar>
<div class="content">
  <router-outlet></router-outlet>
</div>
<avr-footer></avr-footer>

